module.exports = __webpack_public_path__ + "static/favicon-d93ff42b10b76b97eaa8da553534f770.ico";